import { LinkDialogComponent } from '../../../../Dialogs/components/LinkDialog/link-dialog.component';
import { LinkTypeEnum } from '../../../enums/link-type.enum';
import { DropdownOptionModel } from '../../../models/dropdown-option.model';
import { LinkModel } from '../../../models/link.model';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { Injectable } from '@angular/core';
import { Editor, Plugin } from '@ckeditor/ckeditor5-core';


@Injectable()
export class CKLinkService {

    constructor(public coreDialogService: CoreDialogService) {}

    public setUpLinkDialog(editor: Editor): void {
        (editor.plugins.get('agprLinkUI') as Plugin)?.on('linkChange', (event, newValue) => {
            const initialLink = newValue ? new LinkModel().decodeUrl(newValue) : new LinkModel();
            const ioModel = {
                inputs: {
                    heading: 'Common.dialog.linkType.insertLink',
                    link: initialLink,
                    availableLinkTypes: [
                        new DropdownOptionModel('Common.dialog.linkType.webAddress', LinkTypeEnum.URL),
                        new DropdownOptionModel( 'Common.dialog.linkType.emailAddress', LinkTypeEnum.EMAIL)
                    ],
                    isLinkField: true
                },
                outputs: {
                    dialogClose: (link: LinkModel) => {
                        if (link) {
                            editor.fire('linkInput', link.url || link.encodeMailTo());
                        }
                    },
                    removeLink: () => {
                        editor.fire('unlinkInput');
                    }
                }
            };

            this.coreDialogService.open(LinkDialogComponent, ioModel);
        });
    }
}
